/* eslint-disable @typescript-eslint/no-explicit-any */

import { useState } from 'react';
import { DataAPIClientError } from './DataAPIClient';
import { useDataAPIClient } from './DataAPIClientProvider';

interface State {
  data?: string;
  error?: DataAPIClientError;
  isProcessing: boolean;
}

interface Result extends State {
  invoke: (reportID: string) => void;
}

export default function useDataAPIDeactivateReport(): Result {
  const client = useDataAPIClient();

  const [state, setState] = useState<State>({ isProcessing: false });

  async function invoke(reportID: string): Promise<void> {
    setState({ isProcessing: true });

    try {
      const data = await client.deactivateReport(reportID);

      setState({ data, isProcessing: false });
    } catch (error: any) {
      setState({ error, isProcessing: false });
    }
  }

  return { ...state, invoke };
}
